import { createContext } from "react";
import { makeAutoObservable, observable, toJS  } from "mobx";
import { preferenceService } from "../services/preferenceService";
import { profileService } from "../services/profileService";
import { getCurrentUser } from "../../../Utility/modules/helpers";

class ProfileStore {
  constructor() {
    makeAutoObservable(this);
  }

  userprofile = {};
  loadedprofile = false;
  editPassword = false;
  editPhone = false;
  editEmail = false;
  isSaving = false;
  selectKey = "1";
  async setUserNavigationPreference(userId, collapsed) {
    try {
      await preferenceService.setIsNavigationBarCollapsed(collapsed, userId);
    } catch (error) {
      throw error;
    }
  }

  async setUserLastVisitedUrl(url, menuId) {
    try {
      const currentUser = getCurrentUser();
      const { id } = currentUser;
      console.log(url, id, menuId);
      await profileService.setLastUrl(url, id, menuId);
    } catch (error) {
      //intentionally swallow the error to avoid breakage just want to log url alone--failsafe method
      throw error;
    }
  }

  async getUserProfile() {
    try {
      const currentUser = getCurrentUser();
      const { id } = currentUser;

      if (!this.loadedprofile) {
        this.userprofile = await profileService.getUserProfile(id);
        this.loadedprofile = true;
        console.log(toJS(this.userprofile));
      }
    } catch (error) {
      throw error;
    }
  }
  async updateUserProfile(data) {
    try {
      this.isSaving = true;
      const res = await profileService.updateProfile(data);
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    }
  }
  async changePassword(password) {
    try {
      const currentUser = getCurrentUser();
      const { id } = currentUser;
      this.isSaving = true;
      const res = await profileService.changePassword(id, password);
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    }
  }
}


export default createContext(new ProfileStore());

